import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';
import { useResendAdminInvitation } from '../../../hooks/api/use-resend-admin-invitation';

interface Props extends DialogActions {
  token: string;
  email: string;
}

const ResendInvitationDialog = ({ open, onCancel, token, email }: Props) => {
  const { t } = useTranslation(['organizationDetails', 'common']);

  const {
    mutate: resendAdminInvitation,
    isPending: isLoadingResendAdminInvitation,
  } = useResendAdminInvitation(onCancel);

  const handleResendAdminInvitation = () => {
    resendAdminInvitation(token);
  };

  return (
    <Dialog
      title={t('organizationDetails:admins.resendInvitationDialog.title')}
      open={open}
      variant="warning"
      onCancel={onCancel}
      onConfirm={handleResendAdminInvitation}
      cancelButtonText={t('common:no')}
      confirmButtonText={t(
        'organizationDetails:admins.resendInvitationDialog.confirmButtonText',
      )}
      isConfirmButtonSubmitting={isLoadingResendAdminInvitation}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography variant="body2">
          {t(
            'organizationDetails:admins.resendInvitationDialog.descriptionFirst',
            {
              email,
            },
          )}
        </Typography>
        <Typography variant="body2">
          {t(
            'organizationDetails:admins.resendInvitationDialog.descriptionSecond',
          )}
        </Typography>
      </Box>
    </Dialog>
  );
};

export default ResendInvitationDialog;
